import React, { Component } from "react";
import "./bulk-upload.styles.css";

import { selectUserData } from "../../redux/user/user.selectors";
import {
  Spin,
  message,
  Button,
  Upload,
  Typography,
  Row,
  Col,
  Card,
  Breadcrumb,
  Tag,
  Icon,
  List,
  Divider,
} from "antd";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withRouter, Switch as RouteSwitch } from "react-router-dom";

import { baseURL } from "../../api";
import moment from "moment";
import Axios from "axios";

import {
  setScreenName,
  setScreenType,
  setUploadFile,
} from "../../redux/arrival-entry/arrival-entry.actions";
import {
  selectScreenName,
  selectScreenType,
} from "../../redux/arrival-entry/arrival-entry.selectors";
import upload_file from "../../assets/upload_file.svg";
import upload_file_filled from "../../assets/upload_file_filled.svg";
import lightbulb from "../../assets/lightbulb.svg";
import rule from "../../assets/rule.svg";
import packageJson from "../../../package.json";

const FileDownLoad = require("js-file-download");

/**
 * @component
 * @description The parent component for arrival entry page.
 *
 *
 */
class BulkUploadExcel extends Component {
  state = {
    isSpinnerOn: false,
  };

  render() {
    const { screenName, screenType, setScreenName, setUploadfile } = this.props;

    const uploadProps = {
      accept: ".xlsx,.xls",
      showUploadList: false,
      customRequest: async ({ file }) => {
        try {
          const formData = new FormData();
          formData.append("file", file);

          setUploadfile(file);
          setScreenName(3);
        } catch (error) {
          message.error("Upload failed");
        } finally {
        }
      },
    };
    return (
      <Spin spinning={this.state.isSpinnerOn} tip="Loading...">
        {screenType == "mandi" ? (
          <div
            className="uploadexcel-page-container"
            // style={{ height: window.innerHeight - 85 }}
          >
            <Breadcrumb
              separator={
                <Icon
                  type="right"
                  style={{ color: "#002045", fontSize: 10, fontWeight: 700 }}
                />
              }
              style={{ marginBottom: 20 }}
            >
              <Breadcrumb.Item>Arrival</Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => setScreenName(1)}>
                <a>Bulk Upload</a>
              </Breadcrumb.Item>
              <Breadcrumb.Item style={{ color: "#002045", fontWeight: 500 }}>
                Mandi Data
              </Breadcrumb.Item>
            </Breadcrumb>
            <Row
              type="flex"
              justify="space-between"
              align="stretch"
              style={{ marginBottom: 10 }}
            >
              <Col span={12}>
                <Typography.Title
                  level={2}
                  style={{ margin: 0, fontWeight: 700 }}
                >
                  Bulk Mandi Data Upload
                </Typography.Title>
                <Typography.Text strong>
                  Efficiently process large datasets using our standardized
                  template.
                </Typography.Text>
              </Col>
              <Col span={6}>
                <Tag
                  color="#ebeef0"
                  style={{
                    padding: 10,
                    border: "1px solid #c4c6cf",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      padding: 0,
                    }}
                  >
                    <Icon
                      type="calendar"
                      style={{
                        color: "#0061a5",
                        fontSize: 16,
                        paddingRight: 10,
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        lineHeight: 1.1,
                      }}
                    >
                      <Typography.Text>
                        DATA WILL BE UPLOADED FOR{" "}
                      </Typography.Text>
                      <Typography.Text style={{ fontWeight: 700 }}>
                        {moment().format("MMMM DD, YYYY")}
                      </Typography.Text>
                    </span>
                  </span>
                </Tag>
              </Col>
              <Col span={6}>
                <Button
                  style={{
                    height: 40,
                    color: "#0061a5",
                    background: "#fff",
                    fontSize: 16,
                    fontWeight: 500,
                    border: "1px solid #0061a5",
                  }}
                  onClick={() => {
                    Axios({
                      url: `${baseURL}/download_arrival_excel_temp`,
                      method: "GET",
                      params: { template_type: "mandi" },
                      responseType: "blob",
                      onDownloadProgress: (progressEvent) => {
                        let progress = Math.round(
                          (progressEvent.loaded * 100) / progressEvent.total,
                        );
                        this.setState({ downloaddata: progress });
                      },
                    })
                      .then((response) => {
                        if (response.status !== 204) {
                          FileDownLoad(
                            response.data,
                            "Mandi_BranchName_DDMMYYYY.xlsx",
                          );
                          this.setState({ isSpinnerOnProgress: false });
                          setTimeout(
                            function () {
                              this.setState({ ProgressClicked: false });
                            }.bind(this),
                            5000,
                          );
                        } else {
                          message.warning("File has no data.");
                          this.setState({
                            isSpinnerOnProgress: false,
                            ProgressClicked: false,
                          });
                        }
                      })
                      .catch((err) => {
                        message.error("File cannot be downloaded");
                        this.setState({
                          isSpinnerOnProgress: false,
                          ProgressClicked: false,
                        });
                      });
                  }}
                >
                  <Icon type="download" /> Download Blank Template (.xlsx)
                </Button>
              </Col>
            </Row>
            <Row gutter={[16, 32]}>
              <Col span={14}>
                <Card style={{ borderRadius: 10 }}>
                  <Row gutter={[32, 24]}>
                    <Col span={24}>
                      <span style={{ paddingRight: 10 }}>
                        <img src={upload_file} alt="info" />
                      </span>
                      <Typography.Text strong>UPLOAD DATA FILE</Typography.Text>
                    </Col>
                    <Col span={24}>
                      <Upload.Dragger
                        {...uploadProps}
                        style={{ borderRadius: 10 }}
                      >
                        <Icon
                          type="upload"
                          className="iconinfo"
                          style={{ fontSize: 30, fontWeight: 700 }}
                        />
                        <Typography.Title
                          level={4}
                          style={{ margin: 0, paddingTop: 10 }}
                        >
                          Drag and drop file here
                        </Typography.Title>
                        <Typography.Paragraph
                          style={{ fontSize: 12, paddingBottom: 10 }}
                        >
                          or click to browse your local storage
                        </Typography.Paragraph>
                        <Button
                          style={{ background: "#0061a5", color: "#fff" }}
                          size="large"
                        >
                          Choose File
                        </Button>
                        <Typography.Paragraph
                          style={{
                            fontSize: 12,
                            fontStyle: "italic",
                            paddingTop: 10,
                          }}
                        >
                          Supported format: .xlsx only (Max 1500 rows per
                          upload)
                        </Typography.Paragraph>
                      </Upload.Dragger>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={10}>
                <Card style={{ marginBottom: 10, borderRadius: 10 }}>
                  <Row gutter={[32, 24]}>
                    <Col span={24}>
                      <Icon
                        type="profile"
                        style={{
                          color: "#0061a5",
                          fontSize: 18,
                          paddingRight: 10,
                        }}
                      />
                      <Typography.Text strong>
                        MANDATORY COLUMNS
                      </Typography.Text>
                    </Col>
                    <Col span={24}>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>Branch Name</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>Mandi Name</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>Mandi Status</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>variety Name</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>Arrival in Q</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>min_price</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>max_price</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>modal_price</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>Quality Splits</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>Crop_Type</Typography.Text>
                      </Tag>
                      <Tag
                        color="rgb(216, 216, 216)"
                        style={{
                          padding: "2px 10px",
                          border: "1px solid #c4c6cf",
                          marginBottom: 5,
                        }}
                      >
                        <Typography.Text strong>Remark</Typography.Text>
                      </Tag>
                    </Col>
                  </Row>
                </Card>
                <Card style={{ borderRadius: 10 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <Icon
                        type="info-circle"
                        style={{
                          color: "#0061a5",
                          fontSize: 18,
                          paddingRight: 10,
                        }}
                      />
                      <Typography.Text strong>
                        IMPORTANT INSTRUCTIONS
                      </Typography.Text>
                    </Col>
                    <Col span={1}>
                      <Icon type="key" style={{ color: "#0061a5" }} />
                    </Col>
                    <Col span={23}>
                      <Typography.Text>
                        The <strong>first row</strong> must contain headers
                        exactly as defined in the template. Password-protected
                        files will be rejected.
                      </Typography.Text>
                    </Col>
                    <Col span={1}>
                      <Icon type="ordered-list" style={{ color: "#0061a5" }} />
                    </Col>
                    <Col span={23}>
                      <Typography.Text>
                        Please ensure the template is renamed using your branch
                        name followed by the current date in the format
                        <strong> Mandi_BranchName_DDMMYYYY</strong>. For
                        example:{" "}
                        <strong>
                          Mandi_Bhopal_{moment().format("DDMMYYYY")}
                        </strong>
                        .
                      </Typography.Text>
                    </Col>
                    <Col span={1}>
                      <Icon type="ordered-list" style={{ color: "#0061a5" }} />
                    </Col>
                    <Col span={23}>
                      <Typography.Text>
                        You can upload data for only a single branch at a time.
                      </Typography.Text>
                    </Col>
                    <Col span={1}>
                      <Icon type="ordered-list" style={{ color: "#0061a5" }} />
                    </Col>
                    <Col span={23}>
                      <Typography.Text>
                        Data entries exceeding <strong>1500 rows</strong> should
                        be split into multiple files for optimal processing
                        speed.
                      </Typography.Text>
                    </Col>
                    <Col span={1}>
                      <Icon type="safety" style={{ color: "#0061a5" }} />
                    </Col>
                    <Col span={23}>
                      <Typography.Text>
                        System will perform real-time validation for{" "}
                        <strong>Mandi Name</strong> matches against the Master
                        database.
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </div>
        ) : (
          <div
            className="uploadexcel-page-container"
            // style={{ height: window.innerHeight - 85 }}
          >
            <Breadcrumb
              separator={
                <Icon
                  type="right"
                  style={{ color: "#002045", fontSize: 10, fontWeight: 700 }}
                />
              }
              style={{ marginBottom: 20 }}
            >
              <Breadcrumb.Item>Arrival</Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => setScreenName(1)}>
                <a>Bulk Upload</a>
              </Breadcrumb.Item>
              <Breadcrumb.Item style={{ color: "#002045", fontWeight: 500 }}>
                FOR Data
              </Breadcrumb.Item>
            </Breadcrumb>
            <Row
              type="flex"
              justify="space-between"
              style={{ marginBottom: 20 }}
            >
              <Col span={24}>
                <Typography.Title
                  level={2}
                  style={{ margin: 0, fontWeight: 700 }}
                >
                  FOR Data Upload
                </Typography.Title>
              </Col>
              <Col
                span={10}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography.Text strong>
                  Upload Freight On Road logistics data via template.
                </Typography.Text>
                <Typography.Text style={{ color: "#002045" }}>
                  <Icon type="calendar" /> Data will be uploaded for:{" "}
                  {moment().format("MMMM DD, YYYY")}
                </Typography.Text>
              </Col>
              <Col offset={6} span={8} style={{ textAlign: "right" }}>
                <Button
                  style={{
                    height: 40,
                    color: "#0061a5",
                    background: "#fff",
                    fontSize: 16,
                    fontWeight: 500,
                    border: "1px solid #0061a5",
                  }}
                  onClick={() => {
                    Axios({
                      url: `${baseURL}/download_arrival_excel_temp`,
                      method: "GET",
                      params: { template_type: "for" },
                      responseType: "blob",
                      onDownloadProgress: (progressEvent) => {
                        let progress = Math.round(
                          (progressEvent.loaded * 100) / progressEvent.total,
                        );
                        this.setState({ downloaddata: progress });
                      },
                    })
                      .then((response) => {
                        if (response.status == 200) {
                          FileDownLoad(
                            response.data,
                            "FOR_BranchName_DDMMYYYY.xlsx",
                          );
                          this.setState({ isSpinnerOnProgress: false });
                          setTimeout(
                            function () {
                              this.setState({ ProgressClicked: false });
                            }.bind(this),
                            5000,
                          );
                        } else {
                          message.warning("File has no data.");
                          this.setState({
                            isSpinnerOnProgress: false,
                            ProgressClicked: false,
                          });
                        }
                      })
                      .catch((err) => {
                        message.error("File cannot be downloaded");
                        this.setState({
                          isSpinnerOnProgress: false,
                          ProgressClicked: false,
                        });
                      });
                  }}
                >
                  <Icon type="download" /> Download Blank Template (.xlsx)
                </Button>
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={32}>
              <Col span={15}>
                <Upload.Dragger {...uploadProps} style={{ borderRadius: 10 }}>
                  <span style={{ marginBottom: 20 }}>
                    <img
                      src={upload_file_filled}
                      className="iconinfofilled"
                      alt="info"
                    />
                  </span>
                  <Typography.Title level={4}>
                    Select a file to upload
                  </Typography.Title>
                  <Typography.Paragraph>
                    Drop your FOR data file here or browse from your <br />{" "}
                    computer. Only{" "}
                    <strong style={{ color: "#0061a5" }}>.xlsx</strong> formats
                    is supported.
                  </Typography.Paragraph>
                  <Button
                    style={{
                      background: "#0061a5",
                      color: "#fff",
                      marginBlock: 20,
                    }}
                    size="large"
                  >
                    Browse Files
                  </Button>
                  <br />
                  <Typography.Text style={{ fontSize: 11 }}>
                    <Icon type="safety" /> Validated Structure
                  </Typography.Text>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Typography.Text style={{ fontSize: 11 }}>
                    <Icon type="dashboard" /> Fast Processing
                  </Typography.Text>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Typography.Text style={{ fontSize: 11 }}>
                    <Icon type="file-text" /> Max 50MB
                  </Typography.Text>
                </Upload.Dragger>
              </Col>
              <Col span={8}>
                <Card style={{ marginBottom: 20, borderRadius: 10 }}>
                  <Row gutter={24}>
                    <Col span={24}>
                      <span style={{ paddingRight: 10 }}>
                        <img src={rule} alt="mantatory column" />
                      </span>
                      <Typography.Text strong>
                        MANDATORY COLUMNS
                      </Typography.Text>
                      <Divider style={{ marginBottom: 0, marginTop: 10 }} />
                    </Col>
                    <Col span={24}>
                      <List
                        itemLayout="horizontal"
                        dataSource={[
                          "Branch Name",
                          "Destination",
                          "Variety Name",
                          "Quoted Quantity",
                          "min_price, max_price",
                          "landed_price, quality",
                          "Crop_Type, Remark",
                          "FOR Status",
                        ]}
                        renderItem={(item) => (
                          <List.Item
                            style={{
                              flex: "row",
                              background: "rgb(231, 231, 231)",
                              justifyContent: "space-between",
                              borderLeft: "4px solid #0061a5",
                              marginBlock: 10,
                              padding: 10,
                            }}
                          >
                            <Typography.Text strong>{item}</Typography.Text>
                            <Tag color="#66affe">REQUIRED</Tag>
                          </List.Item>
                        )}
                      />
                    </Col>
                  </Row>
                </Card>
                <Card
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    background: "#002045",
                    color: "#fff",
                    borderRadius: 10,
                  }}
                >
                  <img
                    src={lightbulb}
                    alt=""
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: "-1rem",
                      width: 110,
                      opacity: 0.5,
                      pointerEvents: "none",
                      color: "#fff !important",
                    }}
                  />
                  <Typography.Title level={4} style={{ color: "#fff" }}>
                    UPLOAD INSTRUCTIONS
                  </Typography.Title>
                  <div>
                    <Typography.Text
                      style={{
                        color: "#74c2fa",
                        fontSize: 12,
                        display: "block",
                        marginBottom: 10,
                      }}
                    >
                      Ensure all headers match the template exactly. Missing
                      columns or renamed headers will cause the validation to
                      fail. Numerical fields should not contain special
                      characters.
                    </Typography.Text>
                    <Typography.Text
                      style={{ color: "#fff", display: "block", fontSize: 11 }}
                    >
                      <Icon type="info-circle" style={{ paddingRight: 10 }} />
                      Version {packageJson.version} Validation Engine
                    </Typography.Text>
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setScreenName: (screenName) => dispatch(setScreenName(screenName)),
    setScreenType: (type) => dispatch(setScreenType(type)),
    setUploadfile: (file) => dispatch(setUploadFile(file)),
  };
};

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  screenName: selectScreenName,
  screenType: selectScreenType,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BulkUploadExcel),
);
